<template>
    <div class="container">
        <LimsMenu @productsSelect="productsSelect"/>
        <div>
            <div class="introduction" >
                <div class="introductionTitle">
                    <h1 data-aos="fade-up">iLab智慧实验室管理系统</h1>
                    <div data-aos="fade-up"></div>
                    <div data-aos="fade-up">iLab 智慧实验室管理系统，将实验记录、试剂耗材、实验产物信息库存管理、生产流程管理、数据处理等能力有机整合，包含电子记录、样品管理、项目管理、库存管理、数据管理、质量管理六大模块。系统提供多样化记录方式与灵活的模板定制能力，支撑样品全业务链路管理，实时展示实验室工作进展；支持库存数据、实验结果、实验室仪器设备数据对接整合，满足审计追踪与实验数据偏差管理相关要求。</div>
                    <div data-aos="fade-up">系统规范化归集实验室各类数据信息，打通数据孤岛，充分释放数据价值，助力实验室实现数字化管理，提高实验室管理水平。</div>
                </div>
                <div data-aos="zoom-in" >
                    <img :src="require('@/assets/img/products/iLab/introductionTitle.png')" alt="">
                </div>
            </div>
            <div class="function">
                <div class="functionTitle" data-aos="fade-up"></div>
                <div class="pic" data-aos="zoom-in"><img :src="require('@/assets/img/products/iLab/functionPic.jpg')" alt=""></div>
            </div>
            <div class="content">
                <div v-for="item in content">
                    <div class="contentTitle" data-aos="fade-up">{{item.title}}</div>
                    <div class="contentText" data-aos="fade-up">{{item.text}}</div>
                    <div v-if="item.pic !== undefined" style="text-align: center">
                        <img :src="item.pic" alt="" data-aos="zoom-in">
                    </div>
                    <div v-for="list in item.list" >
                        <div class="listTitle" data-aos="fade-up">{{list.name}}</div>
                        <div v-for="arr in list.item" class="listText" data-aos="fade-up">
                            <span style="width: 5px;height:5px;background:#000;border-radius: 50%;display: inline-block;margin-right: 5px"></span>
                            {{arr}}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LimsMenu from "../../components/LimsMenu";

export default {
	components: {LimsMenu},
	data() {
		return {
            content:[
                {
                    title:'仪器设备资产管理',
                    text:'实验室中的重要资产——仪器设备的管理，包括电子台账、盘点、报修、异常报警、利用率监测、共享与预约等;实现简便高效的数字化实验室资产管理。',
                    list:[
                        {
                            name:'资产管理',
                            item:[
                                '展示设备实验室平面分布信息','每月维修服务与计划服务已完成、待完成设备数量','各实验室设备运行情况总结','服务工程师每月计划服务完成准时情况与服务类型占比信息'
                            ]
                        },
                        {
                            name:'设备列表',
                            item:[
                                '资产详细信息:资产全部信息记录，可更改设备图片及设备在实验室平面图中的位置','维修信息:实验室仪器设备一键/自动服务请求'
                            ]
                        },
                        {
                            name:'报警列表',
                            item:[
                                '报警信息综合处理:结合iLab不同监控对象的报警信息，集中展示综合处理','报警信息记录、分类、可追溯:集中展示iLab不同监控对象的报警信息','报警处理结果分析:标记报警信息处理状态以及报警原因填写，处理措施记录等'
                            ]
                        },
                        {
                            name:'仪器设备利用率监控及分析',
                            item:[
                                '一键生成监控月度报表:选择监控历史月份，一键生成报警数据月度报表','月度监控数据总览:智能统计设备月度运行数据，报警数据，服务及预约数据等','仪器利用率TOP统计:以TOP柱状图形式呈现仪器利用率信息',
                                '与上月利用率数据对比:对比分析上月仪器利用率数据，并以TOP柱状图形式直观展示','设备共享预约机制:设备共享预约，错峰使用、收费使用','快速查询预约设备:快速查询设备，查看设备预约信息',
                                '预约时间段一览表:查看可预约时间，选择可预约时间段预约设备','设备详情、预约记录展示:查看设备预约信息记录、设备预约使用记录','共享预约财务报表:定义设备收费规则，自动计算设备预约使用费用详情，生成收入金额报表'
                            ]
                        },
                    ]
                },
                {
                    title:'样本监测与管理',
                    text:'对实验室最珍贵的样本进行全方位的监测与管理',
                    list:[
                        {
                            name:'样本全生命周期数字化管理流程–质控管理–温度监控',
                            item:[
                                '冰箱门状态、温度实时监测:采用门状态传感器和温度传感器与物联网智能终端连接使用，实时传输冰箱维持正常运行关键参数。',
                                '液氮罐温度实时监测:对于低于-130℃的储存环境——液氮罐，至关重要的是要始终保持样品在低于-130℃的环境中。通过温度传感器结合智能终端的实时监测，可以实现在温度出现异常时，以最快时间发现异常，为挽救珍贵样品争取宝贵的时间。'
                            ]
                        },
                        {
                            name:'样本全生命周期数字化管理流程–智能化提醒',
                            item:[
                                '监控数据实时曲线∶实时显示传感器收集的监控数据，智能分析处理的同时，以图表的形式直观展示数据走向','灵活设置报警规则:灵活定义数据异常报警规则，数据发生异常智能触发报警',
                                '智能报警通知∶提供多种报警通知方式选择，可设置报警升级机制,多级响应等，确保报警及时可靠的通知给合适的人','超低温冰箱故障预警︰在故障未“显现”时发出报警，保护价值连播的实验样本'
                            ]
                        },
                    ]
                },
                {
                    title:'化学品管理',
                    text:'结合loT＋ RFID＋供应链管理解决方案，智能监控化学品入库、领取、归还、报废全生命周期管理',
                    list:[
                        {
                            name:'快速查找样品存放位置',
                            item:[
                                '根据样品信息，快速匹配查找样品存放位置信息，让科学家迅速找到样品所在位置，取用更高效。'
                            ]
                        },
                        {
                            name:'样品库存管理',
                            item:[
                                '结合loT +RFID＋供应链管理解决方案，智能统计样品库存信息，出库入库自动记录'
                            ]
                        },
                        {
                            name:'样品取用归还记录',
                            item:[
                                '自动记录样品出库入库信息,实时更新样品存放信息'
                            ]
                        },
                        {
                            name:'样品存放位置错误报警',
                            item:[
                                '定义样品存放规范，样品位置信息错误实时报警，及时避免化学品因存放错误产生化学反应的隐患'
                            ]
                        },
                        {
                            name:'样品低库存报警',
                            item:[
                                '定义样品最低库存信息，样品低于库存阈值触发报警，提醒管理者及时补充化学品'
                            ]
                        },
                        {
                            name:'样品过期报警',
                            item:[
                                '初始化化学品生产日期，超过保质期触发报警，提醒管理者及时清除过期化学品'
                            ]
                        },
                    ]
                },
                {
                    title:'实验室安全监测',
                    text:'实验室安全管理，功能模块包含实验室环境监测，视频监测，电回路负荷监测预警等。实现全方位实验室环境监控，保障实验室安全合规。',
                    list:[
                        {
                            name:'视频监控整合',
                            item:[
                                '整合实验室视频监控系统,或搭建全方位实验室智能监控体系'
                            ]
                        },
                        {
                            name:'实时画面播放',
                            item:[
                                '视频画面支持实时在线播放,历史监控画面搭放'
                            ]
                        },
                        {
                            name:'智能移动侦测',
                            item:[
                                '智能识别彀取异常视频片段'
                            ]
                        },
                        {
                            name:'异常识别报警',
                            item:[
                                '结合人工智能视频识别技术,监测画面异常，并实时报警'
                            ]
                        },
                        {
                            name:'实验室电回路监测',
                            item:[
                                '以电路回路为单位,监测仪器所属回路负荷状态'
                            ]
                        },
                        {
                            name:'实时监测仪器电路负荷数据',
                            item:[
                                '实时更新回路功率负荷数据'
                            ]
                        },
                        {
                            name:'超负荷实时报警',
                            item:[
                                '设置回路负荷报警阈值,超额实时报警'
                            ]
                        },
                        {
                            name:'自动更新回路功率历史最高值',
                            item:[
                                '统计设备及回路历史最高功率值'
                            ]
                        },
                        {
                            name:'超额回路预警',
                            item:[
                                '一键筛选超额回路信息，并支持下载回路负荷数据信息报表，预警设备电路状态'
                            ]
                        },
                    ]
                },
                {
                    title:'物联网数据大屏',
                    text:'依托iLab丰富且全面的监控数据，可根据业务场景的不同定制数据大屏显示页面，让管理者只需要通过一块屏幕就可以总览实验室运行状态。',
                    list:[],
                    pic:require('@/assets/img/products/iLab/content1.png')
                },
                {
                    title:'我们的优势',
                    text:'',
                    list:[],
                    pic:require('@/assets/img/products/iLab/content2.png')
                }
            ]
        }
	},
    methods:{
	    productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 1100px;
        margin: 213px 100px 0;
        display: flex;
        justify-content: space-between;
        .introductionTitle{
            width: 493px;
            padding-top: 100px;
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 65px;
                height: 2px;
                background: #006efd;
                margin: 13px 0 50px 0px;
            }
            &>div:nth-child(3),&>div:nth-child(4){
                font-size: 14px;
                letter-spacing: 1px;
                text-indent: 2em;
                line-height: 30px;
                text-align: justify;
            }
        }
    }
    .function{
        margin-top: 120px;
        .functionTitle{
            width: 289px;
            height: 54px;
            background:url("../../assets/img/products/iLab/functionTitle.png") no-repeat;
            margin: 0 35%;
        }
        .pic{
            width: 100%;
            padding-left: 12.5%;
            margin-top: 100px;
            box-sizing: border-box;
        }
    }
    .content{
        width: 1100px;
        margin-left: 10%;
        margin-top: 40px;
        .contentTitle{
            background-color: #006efd;
            font-family: SourceHanSansCN-Medium;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #ffffff;
            line-height: 25px;
            text-align: center;
            padding: 0 20px;
            height: 25px;
            display: inline-block;
            margin-bottom: 27px;
        }
        .contentText{
            font-size: 15px;
            padding-left: 23px;
            margin-bottom: 42px;
            line-height: 20px;
        }
        .listTitle{
            font-size: 14px;
            color: #000;
            font-weight: bold;
            margin-bottom: 10px;
            letter-spacing: 1px;
            padding-left: 34px;
            margin-top: 36px;
        }
        .listText{
            padding-left: 23px;
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 25px;
            display: flex;
            /*align-items: center;*/
            span{
                margin-top: 10px;
            }
        }
        &>div{
            &>div:last-child{
                margin-bottom: 60px;
            }
        }
    }
</style>
